import { normalizeCollabLogin } from './orderCollabStorage';

const FAB_VISIBLE_PREFIX = 'b2b-order-activity-fab-visible:';

export const activityFabStorageKey = (login: string | null | undefined, orderId: number) =>
    `${FAB_VISIBLE_PREFIX}${normalizeCollabLogin(login)}:${orderId}`;

export const isActivityFabVisible = (login: string | null | undefined, orderId: number) =>
    localStorage.getItem(activityFabStorageKey(login, orderId)) === '1';

export const setActivityFabVisible = (
    login: string | null | undefined,
    orderId: number,
    visible: boolean
) => {
    const key = activityFabStorageKey(login, orderId);

    if (visible) {
        localStorage.setItem(key, '1');
        return;
    }

    localStorage.removeItem(key);
};
